<template>
	<a role="button" @click="rollDice(dataDiceNotation)" class="btn btn-link p-0">
		<slot></slot>&nbsp;<font-awesome-icon icon="dice" size="lg"></font-awesome-icon>
	</a>
</template>

<script>
export default {
	props: [
		'dataDiceNotation',
	],
	methods: {
		rollDice: function( diceNotation ){
			this.$store.dispatch('modals/dice/roll', diceNotation)
		}
	}
}
</script>

<style scoped>

</style>